<script
  setup
  lang="ts"
  generic="T extends string | number | symbol | undefined"
>
interface Props {
  states: T[];
  value: T;
}
defineProps<Props>();

const emit = defineEmits<{
  (e: "update:value", state: T): void;
}>();

defineOptions({
  name: "InputStateToggle"
});
</script>

<template>
  <div class="input-state-toggle">
    <button
      v-for="state of states"
      :key="state"
      type="button"
      class="input-state-toggle__button"
      :class="{ '-is-active': state == value }"
      @click.prevent="emit('update:value', state)"
    >
      <slot :state="state">{{ state }}</slot>
    </button>
  </div>
</template>

<style lang="scss">
.input-state-toggle {
  width: 100%;
  display: flex;
  padding: 0.375rem;
  border-radius: 7px;
  background-color: rgba(var(--tint-contrast), 0.02);
  gap: 0.5rem;
  box-shadow: inset 0 0 5px var(--color-shadow-1);

  &__button {
    width: 100%;
    border-radius: 5px;
    min-width: 0;
    border: 1px solid transparent;
    padding: 0.25rem;
    color: var(--color-text-medium);
    font-size: 13px;
    transition:
      border-color 200ms ease,
      background-color 200ms ease,
      box-shadow 100ms ease,
      color 100ms ease;

    &.-is-active {
      border: 1px solid var(--color-border);
      background-color: var(--color-background-deep);
      box-shadow: 0 0 6px var(--color-shadow-2);
      font-weight: 500;
      color: var(--color-text);
    }

    &:hover {
      color: var(--color-text);
      background-color: var(--color-background-deep);
    }

    &:focus-visible {
      border-color: var(--color-primary);
      outline: 2px solid var(--color-primary);
    }
  }
}
</style>
